module.exports = __webpack_public_path__ + "static/media/42.24a1d13b.jpg";